/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface BusinessObjectDefinitionColumnUpdateRequest { 
    /**
     * Description of the Business Object Definition Column
     */
    description?: string;
    /**
     * An optional boolean flag that specifies if this column is a primary key column or belongs to a set of primary key columns                
     */
    isPrimaryKeyColumn?: boolean;
}
